const ICON_SIZE_TOKEN_TO_CLASS = {
  default: 'icon-size--default',
  medium: 'icon-size--medium',
  large: 'icon-size--large',
} as const;

export type IconSizeToken = keyof typeof ICON_SIZE_TOKEN_TO_CLASS;

export const resolveIconSizeToken = (token?: string | null): string => {
  if (!token) {
    return ICON_SIZE_TOKEN_TO_CLASS.default;
  }

  return (
    ICON_SIZE_TOKEN_TO_CLASS[token as IconSizeToken] ??
    ICON_SIZE_TOKEN_TO_CLASS.default
  );
};
